import { css } from '@emotion/react';
import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { BREAKPOINTS, Flex, maxMediaQuery } from '@inflearn/ds-react';
import type { ParseKeys } from 'i18next';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import CustomHead, { type CustomHeadProps } from '../CustomHead';
import { DefaultGuard } from '../DefaultLayout';
import Header from '../Header';

interface LayoutProps {
  guard?: ({ children }: { children: ReactNode }) => EmotionJSX.Element;
  meta: CustomHeadProps & { title: ParseKeys; description: ParseKeys; siteTitle?: ParseKeys };
  children: ReactNode;
}

const Layout = ({ guard: Guard = DefaultGuard, meta, children }: LayoutProps) => {
  const { t } = useTranslation();

  return (
    <>
      <CustomHead
        {...meta}
        title={t(meta.title)}
        description={t(meta.description)}
        siteTitle={t(meta.siteTitle || '인프런')}
        pageCategory={t('메타.계정.페이지카테고리')}
      />
      <Guard>
        <Flex direction="column" align="center" px={16} py={72} mx="auto" w={360} css={styleLayout}>
          <Header />
          {children}
        </Flex>
      </Guard>
    </>
  );
};

const styleLayout = css({
  [maxMediaQuery(BREAKPOINTS.sm)]: {
    padding: '32px 16px',
    width: '100%',
  },
});

export default Layout;
